import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const initGSAPStackedGallery = () => {
	const root = document.querySelector('.hoffman-posters');
	
	

	if (!root) return;

	
	const images = root.querySelectorAll('.medias img');

	if (!images.length) return;

	gsap.set(images, { autoAlpha: 0, scale: 0.8 });

	images.forEach((image) => {
		gsap.set(image, {
			xPercent: (Math.random() - 0.5) * 10,
			yPercent: (Math.random() - 0.5) * 10,
			rotation: (Math.random() - 0.5) * 50,
		});
	});

	ScrollTrigger.create({
		trigger: root,
		start: 'top 50%',
		onEnter: () => {
			gsap.to(images, {
				autoAlpha: 1,
				scale: 1,
				duration: 0.6,
				ease: 'power4.out',
				stagger: 0.15,
			});
		},
	});
};

export { initGSAPStackedGallery };